import 'vite/modulepreload-polyfill';
import TopMessageHandler from '@/library/topMessageHandler';
import axios from 'axios';
import {createApp, version} from 'vue';
import './directives';
import './filters';
import './init';
import App from './App.vue';
import {initVueApp} from './init';
import EditBlockHandler from './library/intranet/editBlockHandler';
import './polyfill';
import store from './store';
import './stylesheet/global.scss';

// @ts-ignore
window.__toCdnUrl = (filename) => '/dist/' + filename;

if (Array.isArray(axios.defaults.transformResponse))
{
    // commit _debug data to updateDebug if an axios request has finished
    axios.defaults.transformResponse.push((data) =>
    {
        if (typeof data === 'object' && data)
        {
            // check store.state.loggedIn to prevent endless redirect @ login mask, if any XHR is executed ...
            if (data.bookmarked > 0)
            {
                store.commit('bookmarkSetId', data.bookmarked);
                delete data.bookmarked;
            }

            if (data.blockManager)
            {
                for (let blockOptions of data.blockManager)
                {
                    new EditBlockHandler(blockOptions);
                }
            }

            if (data._debug)
            {
                store.commit('updateDebug', data._debug);
                delete data._debug;
            }
        }
        return data;
    });
}

if (process.env.NODE_ENV === 'development')
{
    console.info('Running Vue-Version: ' + version);

    if (import.meta.hot)
    {
        import.meta.hot.on('vite:afterUpdate', () => {
            TopMessageHandler.info('HMR calculated', null, 2);
        });
    }
}

// do NOT export/import a Vue instance!
const app = createApp(App);
initVueApp(app);
app.mount('#app');

